import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import allocateCollectorService from "services/allocateCollectorService";

// List Allocate Shipping Unit
export const useListAllocateCollector = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["allocate-collector", params?.page],
    () => allocateCollectorService.listAllocateCollector(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListChangeScheduleByCollector = (
  payload,
  onSuccess,
  onError
) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["list-change-schedule-by-collector", params?.page],
    () => allocateCollectorService.listChangeScheduleByCollector(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_Collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useCreateCollectorScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useMutation(allocateCollectorService.createCollectorScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("allocate_Collector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateCollectorScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useMutation(allocateCollectorService.updateCollectorScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("allocate_Collector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteCollectorScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useMutation(allocateCollectorService.deleteCollectorScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.delete", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.delete", {
              target: t("allocate_Collector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useChangeCollectorType = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useQuery(
    ["change-Collector-type"],
    () => allocateCollectorService.changeCollectorType(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_Collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return Object.entries(data).map(([k, v]) => {
          return {
            value: k,
            label: v,
          };
        });
      },
    }
  );
};

export const useListCollectorFree = ({
  payload = undefined,
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["list-Collector-free"],
    () => allocateCollectorService.listCollectorFree(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_Collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data?.map(item => {
          return {
            value: item.id,
            label: item.display_name,
          };
        });
      },
    }
  );
};

export const useListCollectorCurrent = ({
  payload = undefined,
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useQuery(
    ["list-Collector-current"],
    () => allocateCollectorService.listCollectorCurrent(payload),
    {
      enabled: false,
      retry: 1,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_Collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data?.map(item => {
          return {
            value: item.id,
            label: item.display_name,
          };
        });
      },
    }
  );
};

export const useClearCollectorScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  return useMutation(allocateCollectorService.clearCollectorScheduleChanges, {
    retry: 0,
    onSuccess: res => {
      if (res.data?.result) {
        addToast(
          t("message.clear", {
            target: "lịch phân bổ Collector",
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
      } else {
        addToast(
          formConvertErrorMessage(
            res.data?.message ||
              t("message.clear", {
                target: "lịch phân bổ Collector",
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(res.data);
        }
      }
      if (typeof onSuccess === "function") {
        onSuccess(res);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.clear", {
              target: "lịch phân bổ Collector",
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
